<div *ngIf="orderReady">
    <!-- Header -->
    <div class="modal-header">
        <div class="title">
            <h2 class="modal-title">Informations fiche client</h2>
            <div class="info-client modal-title">
                <div>
                    <h4 style="text-transform: uppercase"><span>
                            Numéro client: {{this.ficheClientInfos.id_fiche_client}}</span></h4>

                </div>
            </div>
        </div>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <!-- Body -->
    <div class="modal-body d-flex flex-column ">
        <div class="info-client-details">

            <div class="d-flex flex-row">
                <!-- Contact -->
                <div class="d-flex flex-column flex-50">
                    <h5>Informations du client</h5>
                    <div class="info-block">
                        <i class="fa fa-user-o" aria-hidden="true"></i>
                        <p>{{this.ficheClientInfos.lastname}} {{this.ficheClientInfos.firstname}}</p>
                    </div>
                    <div class="info-block">
                        <i class="fa fa-home" aria-hidden="true"></i>
                        <p>{{this.ficheClientInfos.street}}, {{this.ficheClientInfos.cp_city}} {{this.ficheClientInfos.city}}</p>
                        <p *ngIf="ficheClientInfos.country">{{ ficheClientInfos.country }}</p>
                    </div>
                    <div class="info-block">
                        <i class="fa fa-envelope-o" aria-hidden="true"></i>
                        <p>{{this.ficheClientInfos.email}}</p>
                    </div>
                    <div class="info-block" *ngIf="this.ficheClientInfos.phone">
                        <i class="fa fa-phone" aria-hidden="true"></i>
                        <p>{{this.ficheClientInfos.phone}}</p>
                    </div>
                </div>
                <div class="d-flex flex-column flex-50">
                    <h5>Compte</h5>
                   
                    <div class="info-block">
                        <i class="fa fa-user" aria-hidden="true"></i>
                        <p>Inscription le <span class="text-bold">{{this.ficheClientInfos.created_at |
                                date:'longDate'}}</span>
                        </p>
                    </div>
                    <div class="info-block" *ngIf="this.ficheClientInfos.updated_at">
                        <i class="fa fa-clock-o" aria-hidden="true"></i>
                        <p>Modifié le <span class="text-bold">{{this.ficheClientInfos.updated_at |
                                date:'longDate'}}</span></p>
                    </div>
                </div>
                <!-- Info connection of account -->

            </div>
        </div>
    </div>
</div>